export default "__VITE_ASSET__DcUheXSq__"